export const setInitialDelayExitFormVariables = () => {
    sessionStorage.setItem("show-on-delay", "0");
    sessionStorage.setItem("show-on-exit", "0");
  };
  
  export const updateDelayExitFormVariables = (value: string) => {
    sessionStorage.setItem("show-on-delay", value);
    sessionStorage.setItem("show-on-exit", value);
  };
  
  export const shouldShowDelayForm = () => {
    if (sessionStorage.getItem("isUserVerified") == "true") {
      return false;
    } else {
      return (
        sessionStorage.getItem("show-on-delay") !== "1" &&
        sessionStorage.getItem("show-on-exit") !== "1"
      );
    }
  };
  
  /* The promotional banner auto-pops only ONCE per browsing session. After the
     user dismisses it, every following page shows just the floating promo icon;
     opening/closing it from that icon is manual and never resets this flag. */
  const PROMOTIONAL_BANNER_SEEN_KEY = "promotional-banner-seen";

  export const hasSeenPromotionalBanner = () => {
    if (typeof window === "undefined") return false;
    try {
      return sessionStorage.getItem(PROMOTIONAL_BANNER_SEEN_KEY) === "1";
    } catch {
      /* Storage can throw in private mode / blocked-cookie browsers — fall back
         to the old behaviour (auto-open) instead of breaking the page. */
      return false;
    }
  };

  export const markPromotionalBannerSeen = () => {
    if (typeof window === "undefined") return;
    try {
      sessionStorage.setItem(PROMOTIONAL_BANNER_SEEN_KEY, "1");
    } catch {
      /* ignore — see above */
    }
  };

  export const setSessionStorage = (key: string, value: string) => {
    sessionStorage.setItem(key, value);
  };
  
  export const getSessionStorage = (key: string) => {
    return sessionStorage.getItem(key);
  };

export const clearSessionStorage = () => {
  sessionStorage.clear();
};